import { Box, Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";

const TanExcelOverviewInfo = (props) => {
  const { open, setOpen } = props;
  return (
    <DialogWrapper
      title="Important Information on Income Tax e-Proceedings Excel Overview"
      open={open}
      setOpen={setOpen}
      width="lg"
    >
      <Box sx={{ padding: 2, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Important Information - Data displayed within Atom Pro (TAN) is retrieved from the Income
          Tax Portal. Please note the following:
        </Typography>
        <ol>
          <li>
            <Typography variant="body1" gutterBottom>
              In Excel Overview data may not include 'Multiple Responses Submitted & Attachments.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" gutterBottom>
              In Excel Overview there may be notices which you won't be able to see in e-Proceedings
              Screen of the Income Tax Portal. But they will appear if you download the Excel Sheet
              available there.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" gutterBottom>
              Duplication of Notices may occur in the Dashboard, Calendar, and Updates Section due
              to same data appearing in the e-Proceedings & Excel Overview.
            </Typography>
          </li>
        </ol>

        <Typography>
          We provide both e-Proceedings & Excel Overview data to minimize confusion and ensure no
          notices are missed due to potential Income Tax Portal limitations.
        </Typography>
      </Box>
    </DialogWrapper>
  );
};

export default TanExcelOverviewInfo;
